import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { contentfulComponentsMap, AtomSectionContext } from '@invitae/cms-blocks';
import { NucleobaseComponentMapContext, NucleobaseEngineContext, BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { useContentfulEngine } from '@invitae/nucleobase-engine-contentful';
import { usePageAudience } from '../../../../hooks/usePageAudience/usePageAudience.esm.js';

var defaultEngine = {
    useEngine: useContentfulEngine,
};
var BaseComponentProvider = function (_a) {
    var nucleobaseConfig = _a.nucleobaseConfig, contentfulConfig = _a.contentfulConfig, engine = _a.engine, page = _a.children, props = __rest(_a, ["nucleobaseConfig", "contentfulConfig", "engine", "children"]);
    usePageAudience({ page: page });
    var customMapping = React.useContext(NucleobaseComponentMapContext);
    if (page.props)
        return React.createElement(React.Fragment, null, page);
    if ((!(page === null || page === void 0 ? void 0 : page.sys) && nucleobaseConfig) || (!(page === null || page === void 0 ? void 0 : page.sys) && contentfulConfig)) {
        console.error("BaseComponentProvider - Contentful's `page` object wasn't passed properly in NucleobaseShell. \\nCheck `page` object in `getServerSideProps()` in [...path].tsx file");
        return (React.createElement("p", { style: { margin: 20 } },
            "It appears you are expecting to see Contentful page using Nucleobase components but the",
            ' ',
            React.createElement("code", { style: { background: 'lightgray' } }, "page"),
            " object from Contentful is empty or invalid."));
    }
    if ((page === null || page === void 0 ? void 0 : page.sys) && !nucleobaseConfig) {
        console.error('BaseComponentProvider - Missing `nucleobaseConfig` in NucleobaseShell');
        return (React.createElement("p", { style: { margin: 20 } },
            "It appears you are expecting to see Contentful page using Nucleobase components but forgot to provide",
            ' ',
            React.createElement("code", { style: { background: 'lightgray' } }, "nucleobaseConfig"),
            " in NucleobaseShell."));
    }
    if ((page === null || page === void 0 ? void 0 : page.sys) && nucleobaseConfig && !contentfulConfig) {
        console.error('BaseComponentProvider - Missing `contentfulConfig` in NucleobaseShell');
        return (React.createElement("p", { style: { margin: 20 } },
            "It appears you are expecting to see Contentful page but forgot to provide",
            ' ',
            React.createElement("code", { style: { background: 'lightgray' } }, "contentfulConfig"),
            " in NucleobaseShell."));
    }
    return (React.createElement(NucleobaseComponentMapContext.Provider, { value: __assign(__assign({}, contentfulComponentsMap), customMapping) },
        React.createElement(NucleobaseEngineContext.Provider, { value: engine !== null && engine !== void 0 ? engine : defaultEngine },
            React.createElement(AtomSectionContext.Provider, { value: { BaseNucleobaseComponent: BaseNucleobaseComponent } },
                React.createElement(BaseNucleobaseComponent, __assign({}, props, { source: page }))))));
};

export { BaseComponentProvider as default };
//# sourceMappingURL=BaseComponentProvider.esm.js.map
